"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOData__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "nounsToken_",
                type: "address",
            },
            {
                internalType: "address",
                name: "nounsDao_",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AmountExceedsBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "FailedWithdrawingETH",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSupportValue",
        type: "error",
    },
    {
        inputs: [],
        name: "MustBeNounerOrPaySufficientFee",
        type: "error",
    },
    {
        inputs: [],
        name: "MustProvideActions",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyProposerCanCreateUpdateCandidate",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposalInfoArityMismatch",
        type: "error",
    },
    {
        inputs: [],
        name: "ProposalToUpdateMustBeUpdatable",
        type: "error",
    },
    {
        inputs: [],
        name: "SlugAlreadyUsed",
        type: "error",
    },
    {
        inputs: [],
        name: "SlugDoesNotExist",
        type: "error",
    },
    {
        inputs: [],
        name: "TooManyActions",
        type: "error",
    },
    {
        inputs: [],
        name: "UpdateProposalCandidatesOnlyWorkWithProposalsBySigs",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "CandidateFeedbackSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldCreateCandidateCost",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newCreateCandidateCost",
                type: "uint256",
            },
        ],
        name: "CreateCandidateCostSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "ETHWithdrawn",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldFeeRecipient",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newFeeRecipient",
                type: "address",
            },
        ],
        name: "FeeRecipientSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "FeedbackSent",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
        ],
        name: "ProposalCandidateCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "encodedProposalHash",
                type: "bytes32",
            },
        ],
        name: "ProposalCandidateCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "msgSender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "encodedProposalHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "ProposalCandidateUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "signer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "expirationTimestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "encodedPropHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "sigDigest",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "SignatureAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldUpdateCandidateCost",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newUpdateCandidateCost",
                type: "uint256",
            },
        ],
        name: "UpdateCandidateCostSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "PRIOR_VOTES_BLOCKS_AGO",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "sig",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "expirationTimestamp",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "encodedProp",
                type: "bytes",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "addSignature",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
        ],
        name: "cancelProposalCandidate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "createCandidateCost",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
        ],
        name: "createProposalCandidate",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "feeRecipient",
        outputs: [
            {
                internalType: "address payable",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "createCandidateCost_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "updateCandidateCost_",
                type: "uint256",
            },
            {
                internalType: "address payable",
                name: "feeRecipient_",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsDao",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nounsToken",
        outputs: [
            {
                internalType: "contract NounsTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        name: "propCandidates",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "sendCandidateFeedback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "sendFeedback",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newCreateCandidateCost",
                type: "uint256",
            },
        ],
        name: "setCreateCandidateCost",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address payable",
                name: "newFeeRecipient",
                type: "address",
            },
        ],
        name: "setFeeRecipient",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newUpdateCandidateCost",
                type: "uint256",
            },
        ],
        name: "setUpdateCandidateCost",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "updateCandidateCost",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                internalType: "string",
                name: "slug",
                type: "string",
            },
            {
                internalType: "uint256",
                name: "proposalIdToUpdate",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "updateProposalCandidate",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "withdrawETH",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class NounsDAOData__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(nounsToken_, nounsDao_, overrides) {
        return super.deploy(nounsToken_, nounsDao_, overrides || {});
    }
    getDeployTransaction(nounsToken_, nounsDao_, overrides) {
        return super.getDeployTransaction(nounsToken_, nounsDao_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOData__factory = NounsDAOData__factory;
NounsDAOData__factory.bytecode = _bytecode;
NounsDAOData__factory.abi = _abi;
